import {
  CONTEXT_MENU_SIZE_SM,
  ContextMenu,
  Flex,
  makeButtonWithMenu,
  Text,
  TEXT_VARIANT_SMALL,
  TEXT_VARIANT_SMALL_LIGHT
} from 'mailup-web-components'
import { useRef } from 'react'

import styled from '@emotion/styled'
import ChevronDownIcon from 'mailup-web-components/bundle/img/icons/chevron-down.svg'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilState } from 'recoil'
import { searchCallback } from '../recoil/callbacks/callbacks'
import { searchState } from '../recoil/state/page'

const StyledText = styled(Text)`
  cursor: pointer;
`

const StyledIcon = styled.img`
  margin-left: 4px;
  height: 10px;
  width: 10px;
  color: var(--boulder);
`

export const OrderBy = () => {
  const intl = useIntl()
  const [{ orderBy }, setSearch] = useRecoilState(searchState)
  const search = useRecoilCallback(searchCallback, [])
  const { idSource } = useParams()

  const { current: handleClickOption } = useRef((orderBy) => {
    setSearch((prev) => ({
      ...prev,
      orderBy
    }))
    search(idSource, false)
  })

  const { current: options } = useRef([
    {
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.ContentDate'
      }),
      value: 'ContentDate',
      onClick: handleClickOption
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.ContentLoadingDate'
      }),
      value: 'ContentLoadingDate',
      onClick: handleClickOption
    }
  ])

  const Component = makeButtonWithMenu(
    () => (
      <Flex justifyContent='flex-end' alignItems='center' columnGap='4px'>
        <Text variant={TEXT_VARIANT_SMALL} htmlElement='span'>
          {intl.formatMessage({ id: 'Load.TableHeader.Order' })}
        </Text>{' '}
        <StyledText variant={TEXT_VARIANT_SMALL_LIGHT} htmlElement='span'>
          {options.find((f) => f.value === orderBy).label}
          <StyledIcon src={ChevronDownIcon} />
        </StyledText>
      </Flex>
    ),
    () => (
      <>
        <ContextMenu
          selected={orderBy}
          items={options}
          size={CONTEXT_MENU_SIZE_SM}
        />
      </>
    )
  )

  return <Component />
}
